import { render, staticRenderFns } from "./Note.vue?vue&type=template&id=4c39f762"
import script from "./Note.vue?vue&type=script&lang=js"
export * from "./Note.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports